export interface GasDatepicker {
  currentDay: Date;
  currentMonth: number;
  currentYear: number;
  lastDay: number;
  indexDay: number;
}

export interface GasPickerDay {
  value: Date;
  otherMonth: boolean;
  isActive: boolean;
  isCurrent: boolean;
  monthIndex?: number;
}

export interface PreviousMonthDate {
  previusMonth: number;
  previusMonthLastDay: number;
  currectIndex: number;
}

export interface NextMonthDate {
  nextMonth: number;
  previusMonthLastDay: number;
}

export interface GasYears {
  currentYear: number;
  minYear: number;
  maxYear: number;
  years: number[];
}

export interface GasDatepickerTime {
  hours: number;
  minutes: number;
  seconds: number;
}

export const MONTH = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

export const DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
